var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKn = function SvgKn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 750 500"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "kn_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h750v500H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#kn_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009e49",
    d: "M750 0H0v500"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M0 500h750V0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fcd116",
    strokeWidth: 210,
    d: "M0 500 750 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 150,
    d: "M0 500 750 0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kn_svg__d",
    fill: "#fff",
    transform: "rotate(-33.69 514.716 -777.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kn_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kn_svg__b",
    d: "M0-70V0h35",
    transform: "rotate(18 0 -70)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kn_svg__b",
    transform: "scale(-1 1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kn_svg__c",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kn_svg__c",
    transform: "rotate(144)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kn_svg__c",
    transform: "rotate(216)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kn_svg__c",
    transform: "rotate(288)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kn_svg__d",
    transform: "translate(-285 190)"
  }))));
};
export default SvgKn;